<template>
  <div id="report_user">
    <v-layout wrap>
      <v-flex xs12 sm6>
        <div class="form-inline form-control">
          <span class="mr-sm-2" for="datepickerInput">Date :</span>
          <datepicker
            :input-class="'form-control'"
            :value="currentDate"
            style="display: inline-block"
            @selected="onDateChange"
          ></datepicker>
          <v-btn outline fab small color="primary" @click="getList()">
            <em class="fa fa-refresh" />
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <span for="autoRefreshInput" style="vertical-align: top; line-height: 2.2em"
          >Auto Refresh</span
        >

        <label class="toggle-switch">
          <input type="checkbox" :checked="isAutoRefresh" @change="enableAutoUpdate()" />
          <span class="toggle-slider lever round"></span>
        </label>
      </v-flex>
    </v-layout>

    <br />
    <table class="zw-table fullwidth border-radius outline">
      <thead>
        <tr class="text-center">
          <th scope="col" width="100">Time</th>
          <th scope="col" width="170">District</th>
          <th scope="col" width="170">Priority</th>
          <th scope="col">Message</th>
          <th scope="col" width="170">Report By</th>
          <th scope="col" width="200">Action</th>
        </tr>
      </thead>
      <tbody>
        <reporter-list-item
          v-for="(report, index) in reporterlist"
          :key="index"
          :problemid="report.id"
          :report="report"
          :pageid="pageid"
          @onDelete="deleteReport($event)"
        ></reporter-list-item>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

import config from '@/config'

import reporterItemList from './reporter-list-item'

export default {
  components: {
    'reporter-list-item': reporterItemList,
    datepicker: datepicker
  },
  data: function () {
    return {
      reporterlist: [],
      currentDate: '',
      timer: '',
      isAutoRefresh: true,
      maxTime: 300000
    }
  },
  computed: {
    pageid() {
      return this.$store.state.selectedBot.pageid
    }
  },
  created: function () {
    this.currentDate = new Date()
    this.getList()
    this.timer = setInterval(this.getList, this.maxTime)
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  methods: {
    onDateChange: function (date) {
      this.currentDate = new Date(date)
      this.getList()
    },
    getList: function () {
      let vm = this
      vm.$store.dispatch('loading')
      axios.defaults.headers.common = {
        AUTHORIZATION: this.$store.getters.securityToken
      }
      axios
        .get(
          config.serverUrl +
            'problemreport?type=user&date=' +
            moment(this.currentDate).format('YYYY-MM-DD') +
            '&pageid=' +
            this.pageid
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          var response = response.data
          if (response.responsecode == 200) {
            this.reporterlist = response.data
            // console.log()
          } else if (response.responsecode == 400) {
            let message = response.reason ? response.reason : ''
            var isFacebook = vm.$store.state.isFacebook
            vm.$store.dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            if (
              vm.$router.history.current.name != 'login' ||
              vm.$router.history.current.name != 'nigol'
            ) {
              if (isFacebook) {
                vm.$router.push('/login')
              } else {
                vm.$router.push('/nigol')
              }
            }
          } else {
          }
          vm.$store.dispatch('loading')
        })
        .catch((e) => {
          console.error(e)
          // this.errors.push(e)
          vm.$store.dispatch('loading')
        })
    },
    deleteReport: function (payload) {
      let vm = this
      const reportIndex = vm.reporterlist.findIndex((report) => {
        return report.id == payload
      })
      vm.reporterlist = vm.reporterlist.splice(reportIndex, 1)
    },
    enableAutoUpdate: function () {
      this.isAutoRefresh = !this.isAutoRefresh
      if (this.isAutoRefresh) {
        this.timer = setInterval(this.getList, this.maxTime)
      } else {
        clearInterval(this.timer)
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/reporter/reporter-user.vue